module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-1.d90f36cf.jpg";